/* GENERATED FILE - do not edit here.
 * source: om-mushrooms ops/quiz/engine/quiz-client.js
 * sha256: e2c5647467f69d356ba109485f2d8237b9b75cfd12d3e981f768bd9017fe02bd
 * regenerate: python3 ops/quiz/cli.py sync-asset (check: cli.py check --theme)
 */
/* ============================================================================
 * ops/quiz/engine/quiz-client.js - the Find Your Match quiz CLIENT
 * ----------------------------------------------------------------------------
 * WHAT IT DOES
 *   Everything with a side effect, kept OUT of the engine so the engine stays
 *   pure and provably offline:
 *     - the OM-owned first-party visitor id (om_vid)        architecture C5.1
 *     - the anonymous telemetry beacon (five events)        C5.2, Decision 15 tier 1
 *     - the one completion write that mints the result link C5.3
 *     - the cart-attribute write of the two OPAQUE ids      C5.4, Decision 15 tier 2
 *     - the emailed-link return visit                       C5.5 (ids only, F-002)
 *     - the capture consent hook                            C5.6, ADR-13 + Decision 27
 *       (GATED BY DEFAULT: nothing is captured until
 *       Shopify.customerPrivacy says analytics are allowed)
 *
 *   A `run` ties one engine session to its telemetry: run.answer() answers the
 *   engine AND emits question_answered, and so on, so a page cannot forget an
 *   event.
 *
 * CONSENT IS THREE-STATE (validation F-012): allowed -> send, denied -> drop,
 *   unknown (Shopify's API not loaded YET) -> HOLD in memory. The API arrives
 *   42-391 ms after the first question on the real storefront; Build 2 read
 *   "not yet" as "denied" and lost quiz_started (the only carrier of
 *   entry_point, SC-1's measure) for every consented visitor. Held capture goes
 *   out in its original order and time on allowed; nothing leaves while unknown.
 *
 * THE COMPLETION KEY (validation F-013): each run's key lives in a file-private
 *   map and leaves the browser only inside the completion write. The host
 *   mints a token for a REPEAT of a quiz_response_id — a join key the cart and
 *   the order expose to everyone — only when the same key comes back.
 *
 * THE RULES THIS FILE ENFORCES
 *   - THE QUIZ FAILS OPEN. Every network call is fire-and-forget or awaited
 *     only on the emailed-link path. The result exists before any write is
 *     attempted; a host outage costs the link and the telemetry, nothing else.
 *     Every transport call is wrapped so a failure can never reach the page.
 *   - ONLY TWO KEYS EVER RIDE THE CART: quiz_response_id and om_visitor_id
 *     (ADR-1). No answer, need, format or recommended product is ever written to
 *     a cart attribute - order attributes are readable by every app with order
 *     scope, and Decision 24 (no quiz answer reaches a marketing platform) must
 *     hold even through that back door. cartAttributeBody() takes nothing else.
 *   - No free text in any event, and no third-party marketing or analytics
 *     layer is touched from this file, ever.
 *
 * HOW TO USE (browser)
 *   var page   = OmQuizClient.readPageContent("om-quiz-content");
 *   var client = OmQuizClient.create({host: page.host, resultBase: location.origin + page.result_path,
 *                                     consentMode: page.consent_mode});
 *   var run    = client.startRun({engine: OmQuiz, content: ladder.content, entryPoint: "nav"});
 *   run.answer(qid, [optionIds]); run.completeGate({email: "...", consent: true});
 *   run.result -> the C9 model (link.status goes pending -> ready | unavailable)
 *
 *   Node / tests: OmQuizClient.create({env: fakeEnv, ...}) — every transport and
 *   store is injectable (C5), so the whole module is testable with no network.
 *
 * WHEN TO CHANGE IT
 *   When an event gains a field (change the host's validator in
 *   ops/quiz/host/app.py in the SAME commit, or the host will 400 the event).
 *   After any edit: bash ops/quiz/tests/run_all.sh, then cli.py sync-asset.
 *
 * DEPENDENCIES
 *   None. ES5-compatible. Uses the engine (quiz-engine.js) passed in.
 * ========================================================================== */

(function (root) {
  "use strict";

  // 1.2.0 (build 3): consent is three-state and capture HOLDS while it is
  // unknown (F-012); every completion carries the run's completion key (F-013).
  // 1.3.0 (2026-09-24): no add-all; result_shown logs start_broad too; an
  // expired link (the host's 410) resolves to a retake model.
  var CLIENT_VERSION = "1.3.0";
  var EVENT_SCHEMA = "om_quiz.event/v1";
  var RETURN_SCHEMA = "om_quiz.return/v1";
  // Decision 27: capture waits for consent unless the content says otherwise.
  // This is the default when a page or a test passes no mode at all.
  var DEFAULT_CONSENT_MODE = "shopify_analytics";
  var HOLD_CAP = 50;                     // events held while consent is unknown (a run is ~15)
  var CONSENT_POLL_MS = 250;             // poll for the consent API every 250 ms...
  var CONSENT_POLL_FOR_MS = 10000;       // ...for 10 s after something is held
  // Completion keys by quiz_response_id (F-013). File-private ON PURPOSE: no
  // run, client or debug hook a page exposes can reach one.
  var RUN_KEYS = {};
  // The HOST's address rule, character for character (ops/quiz/host/app.py
  // EMAIL_RE). One rule on both sides, so an address the page accepts is never
  // one the host throws away (F-006). A shared case table pins the two together.
  var EMAIL_RE = /^[^\s@]{1,64}@[^\s@]{1,190}\.[^\s@]{2,63}$/;
  var VID_NAME = "om_vid";
  var VID_MAX_AGE_S = 34560000;          // 400 days, the browser cap on cookie lifetime
  var EVENT_NAMES = ["quiz_started", "question_answered", "quiz_completed", "result_shown",
                     "recommendation_clicked"];

  // ===========================================================================
  // Pure helpers — no environment access; exported for the Node tests.
  // ===========================================================================
  var B64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_";

  function b64url(bytes) {
    var out = "", i;
    for (i = 0; i + 2 < bytes.length; i += 3) {
      var n = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
      out += B64[(n >> 18) & 63] + B64[(n >> 12) & 63] + B64[(n >> 6) & 63] + B64[n & 63];
    }
    var rem = bytes.length - i;
    if (rem === 1) {
      var a = bytes[i] << 16;
      out += B64[(a >> 18) & 63] + B64[(a >> 12) & 63];
    } else if (rem === 2) {
      var b = (bytes[i] << 16) | (bytes[i + 1] << 8);
      out += B64[(b >> 18) & 63] + B64[(b >> 12) & 63] + B64[(b >> 6) & 63];
    }
    return out;
  }

  // 16 random bytes -> 22 base64url characters (128 bits).
  function randomId(env) { return b64url(env.random(16)); }

  function uuid4(env) {
    var b = env.random(16);
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    var h = [];
    for (var i = 0; i < 16; i++) h.push(("0" + b[i].toString(16)).slice(-2));
    return h.slice(0, 4).join("") + "-" + h.slice(4, 6).join("") + "-" + h.slice(6, 8).join("") + "-" +
           h.slice(8, 10).join("") + "-" + h.slice(10, 16).join("");
  }

  // The client-minted join key (ADR-15): it rides the order, so it is a JOIN key
  // only - it can never resolve a result. The bearer token is server-minted.
  function mintResponseId(env) { return "qr1." + randomId(env); }

  // The stored visitor record is "v1.<22 chars>.<created, base36 seconds>". The
  // id exposed everywhere is "v1.<22 chars>"; the creation time rides along so
  // vid_age_days is MEASURED (Decision 17 is measured, not assumed).
  var VID_RE = /^v1\.([A-Za-z0-9_-]{22})\.([0-9a-z]{1,10})$/;

  function parseVisitorRecord(raw) {
    if (typeof raw !== "string") return null;
    var m = VID_RE.exec(raw);
    if (!m) return null;
    var created = parseInt(m[2], 36);
    if (!(created > 0)) return null;
    return { id: "v1." + m[1], created: created, record: raw };
  }

  function mintVisitorRecord(env) {
    var created = Math.floor(env.now() / 1000);
    return "v1." + randomId(env) + "." + created.toString(36);
  }

  function uaFamily(ua) {
    ua = String(ua || "");
    if (/Edg\//.test(ua)) return "edge";
    if (/SamsungBrowser/.test(ua)) return "samsung";
    if (/Firefox\//.test(ua) || /FxiOS/.test(ua)) return "firefox";
    if (/CriOS/.test(ua) || (/Chrome\//.test(ua) && !/Chromium/.test(ua))) return "chrome";
    if (/Safari\//.test(ua) && /Version\//.test(ua)) return "safari";
    return "other";
  }

  // THE cart body. Exactly two keys, both opaque (ADR-1). There is deliberately
  // no parameter through which an answer could be passed.
  function cartAttributeBody(quizResponseId, visitorId) {
    var attrs = { quiz_response_id: String(quizResponseId || "") };
    if (visitorId) attrs.om_visitor_id = String(visitorId);
    return { attributes: attrs };
  }

  // The result link: the fragment form keeps the token out of server access logs
  // and the Referer header (C9 page constraint 4). The path names no need,
  // product or outcome (Decision 25a).
  function resultUrl(base, token) { return String(base || "").replace(/[#?].*$/, "") + "#r=" + token; }

  function parseResultToken(hash, search) {
    var m = /(?:^|[#&])r=([A-Za-z0-9_-]{22})(?:&|$)/.exec(String(hash || ""));
    if (m) return m[1];
    m = /[?&]r=([A-Za-z0-9_-]{22})(?:&|$)/.exec(String(search || ""));
    return m ? m[1] : null;
  }

  // The address the page may send, or null. Trimmed first: mobile keyboards
  // often add a trailing space after autocomplete, and that is not a typo.
  function validEmail(s) {
    if (typeof s !== "string") return null;
    var t = s.replace(/^\s+|\s+$/g, "");
    return EMAIL_RE.test(t) ? t : null;
  }

  // The five events and exactly the fields each may carry (the host rejects any
  // other key, so a future edit cannot start collecting prose - C5.2).
  function envelope(ctx, name, fields) {
    var e = {
      schema: EVENT_SCHEMA, event: name, event_id: ctx.eventId,
      quiz_response_id: ctx.responseId, visitor_id: ctx.visitorId || null,
      vid_source: ctx.vidSource, vid_age_days: ctx.vidAgeDays,
      occurred_at: new Date(ctx.now).toISOString(), seq: ctx.seq,
      content_version: ctx.contentVersion || null, engine_version: ctx.engineVersion || null,
      synthetic: !!ctx.synthetic
    };
    for (var k in fields) if (Object.prototype.hasOwnProperty.call(fields, k)) e[k] = fields[k];
    return e;
  }

  // result_shown is the learning record (2026-09-24, "log everything"): every
  // product shown with its position (rank) and basis, plus start_broad with its
  // emphasis; the envelope carries the engine and content versions.
  function resultShownFields(model) {
    var cards = [];
    for (var i = 0; i < model.recommendations.length; i++) {
      var c = model.recommendations[i];
      cards.push({ product_id: c.product.id, rank: c.rank, basis: c.basis, confidence: c.confidence });
    }
    var sb = model.start_broad ? { product_id: model.start_broad.product.id, emphasis: model.start_broad.emphasis } : null;
    var adv = [];
    for (i = 0; i < model.advice.length; i++) adv.push(model.advice[i].id);
    return { cards: cards, start_broad: sb, advice_ids: adv, lead_with_advice: !!model.lead_with_advice,
             email_gate: model.email_gate === "pending" ? "skipped" : model.email_gate };
  }

  // ===========================================================================
  // The browser environment. The ONLY place this file touches the page; tests
  // replace the whole object.
  // ===========================================================================
  function browserEnv() {
    var w = typeof window !== "undefined" ? window : {};
    var d = typeof document !== "undefined" ? document : null;
    return {
      now: function () { return Date.now(); },
      random: function (n) {
        var b = new Uint8Array(n);
        (w.crypto || w.msCrypto).getRandomValues(b);
        return b;
      },
      cookieGet: function (name) {
        if (!d) return null;
        var parts = (d.cookie || "").split(/;\s*/);
        for (var i = 0; i < parts.length; i++) {
          var eq = parts[i].indexOf("=");
          if (eq > 0 && parts[i].slice(0, eq) === name) return decodeURIComponent(parts[i].slice(eq + 1));
        }
        return null;
      },
      // Host-only (no Domain attribute), Lax, Secure on https, 400 days.
      cookieSet: function (name, value) {
        if (!d) return;
        var secure = (w.location && w.location.protocol === "https:") ? "; Secure" : "";
        d.cookie = name + "=" + encodeURIComponent(value) + "; path=/; max-age=" + VID_MAX_AGE_S +
                   "; SameSite=Lax" + secure;
      },
      storeGet: function (k) { try { return w.localStorage.getItem(k); } catch (e) { return null; } },
      storeSet: function (k, v) { try { w.localStorage.setItem(k, v); } catch (e) { /* private mode */ } },
      sendBeacon: (w.navigator && typeof w.navigator.sendBeacon === "function")
        ? function (url, body) {
            var blob = new Blob([body], { type: "text/plain;charset=UTF-8" });
            return w.navigator.sendBeacon(url, blob);
          }
        : null,
      fetch: typeof w.fetch === "function" ? function (u, o) { return w.fetch(u, o); } : null,
      // "unknown" = the API is not on the page YET, which is not a refusal (F-012).
      consentState: function () {
        try {
          var cp = w.Shopify && w.Shopify.customerPrivacy;
          if (!cp || typeof cp.analyticsProcessingAllowed !== "function") return "unknown";
          return cp.analyticsProcessingAllowed() ? "allowed" : "denied";
        } catch (e) { return "unknown"; }
      },
      // Ask Shopify to load its Customer Privacy API now (its documented theme
      // mechanism; a Shopify script, never a third party's).
      requestConsentApi: function (cb) {
        try {
          if (w.Shopify && typeof w.Shopify.loadFeatures === "function") {
            w.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () { cb(); });
            return true;
          }
        } catch (e) { /* never block on consent plumbing */ }
        return false;
      },
      // Shopify fires this on the document when the visitor answers the banner.
      onConsentEvent: function (cb) {
        try { if (d && d.addEventListener) d.addEventListener("visitorConsentCollected", function () { cb(); }); }
        catch (e) { /* never block */ }
      },
      userAgent: (w.navigator && w.navigator.userAgent) || "",
      abortController: typeof AbortController !== "undefined" ? function () { return new AbortController(); } : null,
      setTimeout: function (f, ms) { return setTimeout(f, ms); }
    };
  }

  // ===========================================================================
  // The client.
  // ===========================================================================
  function Client(o) {
    this.env = o.env || browserEnv();
    this.host = String(o.host || "").replace(/\/+$/, "");
    this.resultBase = o.resultBase || "";
    // Gated unless told otherwise (Decision 27). "off" must be asked for.
    this.consentMode = o.consentMode || DEFAULT_CONSENT_MODE;
    this.completionTimeoutMs = o.completionTimeoutMs || 5000;
    this.synthetic = !!o.synthetic;
    // How long to poll for the consent API once something is held (tests shorten it).
    this.consentPollForMs = typeof o.consentPollForMs === "number" ? o.consentPollForMs : CONSENT_POLL_FOR_MS;
    // held            capture waiting in memory for consent right now
    // held_flushed    held capture SENT once consent said allowed
    // held_dropped    held capture thrown away (consent said denied, or the cap)
    // beacons_suppressed  events never sent because consent said denied
    this.stats = { beacons_sent: 0, beacon_failures: 0, beacons_suppressed: 0, completion_failures: 0,
                   cart_writes: 0, cart_failures: 0, held: 0, held_flushed: 0, held_dropped: 0 };
    this._identity = null;
    this._held = [];               // capture waiting for consent, IN ORDER — memory only, never sent while unknown
    this._consentHooked = false;   // loadFeatures + the event listener: once per client
    this._polling = false;
  }

  // ===========================================================================
  // Consent (Decision 27, F-012). Capture — cookie, beacon, completion, cart
  // ids — waits on consent ONLY in shopify_analytics mode; the interview and
  // the result never do (ADR-13, SP-8). Re-read at every capture point, never
  // cached: a visitor who allows mid-run is captured from then on (O-7).
  // ===========================================================================
  Client.prototype.consentState = function () {
    if (this.consentMode !== "shopify_analytics") return "allowed";
    var env = this.env;
    try {
      if (typeof env.consentState === "function") {
        var s = env.consentState();
        return (s === "allowed" || s === "denied") ? s : "unknown";
      }
      // An injected environment from before build 3 reports a plain boolean.
      return env.consentAllowed() ? "allowed" : "denied";
    } catch (e) { return "unknown"; }
  };

  Client.prototype.captureAllowed = function () { return this.consentState() === "allowed"; };

  // Park capture until consent is known. Events past the cap are dropped and
  // counted; a second cart write for the same id shares the first one's wait.
  Client.prototype._hold = function (item) {
    if (item.type === "event") {
      var n = 0;
      for (var i = 0; i < this._held.length; i++) if (this._held[i].type === "event") n++;
      if (n >= HOLD_CAP) { this.stats.held_dropped++; this._watchConsent(); return; }
    } else if (item.type === "cart") {
      for (var j = 0; j < this._held.length; j++) {
        if (this._held[j].type === "cart" && this._held[j].rid === item.rid) {
          this._held[j].waiters.push(item.resolve);
          return;
        }
      }
      item.waiters = [item.resolve];
    }
    this._held.push(item);
    this.stats.held = this._held.length;
    this._watchConsent();
  };

  // Settle held capture NOW: at every capture point (older items go first, so
  // order holds), from Shopify's consent callbacks and from the poll. Returns
  // the consent state. Never throws.
  Client.prototype._settleConsent = function () {
    var st = this.consentState();
    if (st === "unknown" || !this._held.length) return st;
    var items = this._held;
    this._held = [];
    this.stats.held = 0;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      try {
        if (st === "allowed") {
          this.stats.held_flushed++;
          if (it.type === "event") this._send(this._stampIdentity(it.ev));
          else if (it.type === "completion") this._sendCompletion(it.body).then(it.resolve);
          else this._writeCart(it.rid).then(this._resolveAll(it.waiters));
        } else {                                              // denied: nothing held is ever sent
          this.stats.held_dropped++;
          if (it.type === "event") this.stats.beacons_suppressed++;
          else if (it.type === "completion") it.resolve({ status: "unavailable", url: null });
          else this._resolveAll(it.waiters)(false);
        }
      } catch (e) { /* one bad item never strands the rest */ }
    }
    return st;
  };

  Client.prototype._resolveAll = function (waiters) {
    return function (v) { for (var i = 0; i < waiters.length; i++) { try { waiters[i](v); } catch (e) {} } return v; };
  };

  // A held event predates the visitor id (no cookie without consent); now it
  // gets this browser's id. Its event id, seq and occurred_at are untouched.
  Client.prototype._stampIdentity = function (ev) {
    var id = this.identity();
    ev.visitor_id = id.visitor_id || null;
    ev.vid_source = id.vid_source;
    ev.vid_age_days = id.vid_age_days;
    return ev;
  };

  // While something is held: ask Shopify for its consent API (once), listen for
  // the banner's answer (once), poll 250 ms for ~10 s. If the API never comes
  // nothing is sent; leaving the page simply forgets the queue.
  Client.prototype._watchConsent = function () {
    var self = this, env = this.env;
    function poke() { try { self._settleConsent(); } catch (e) { /* never throw into Shopify's callback */ } }
    if (!this._consentHooked) {
      this._consentHooked = true;
      try { if (typeof env.requestConsentApi === "function") env.requestConsentApi(poke); } catch (e1) {}
      try { if (typeof env.onConsentEvent === "function") env.onConsentEvent(poke); } catch (e2) {}
    }
    if (this._polling || typeof env.setTimeout !== "function") return;
    this._polling = true;
    var until = env.now() + this.consentPollForMs;
    (function poll() {
      if (self.consentState() !== "unknown") { self._polling = false; poke(); return; }
      if (!self._held.length || env.now() >= until) { self._polling = false; return; }
      env.setTimeout(poll, CONSENT_POLL_MS);
    })();
  };

  // C5.1 — read the cookie, else the localStorage mirror, else mint; either
  // store restores the other, so one cleared store does not reset the id.
  Client.prototype.identity = function () {
    if (this._identity) return this._identity;
    var env = this.env, now = env.now();
    if (!this.captureAllowed()) {
      // No consent YET. Deliberately NOT cached: with capture gated by default,
      // Shopify's consent API often loads after the quiz starts, and a visitor
      // who allows analytics mid-run must be captured from that moment on.
      // Caching the refusal would have lost the whole run (validation O-7).
      return { visitor_id: null, vid_source: "none", vid_age_days: null };
    }
    var fromCookie = null, fromStore = null, src, rec;
    try { fromCookie = parseVisitorRecord(env.cookieGet(VID_NAME)); } catch (e) { fromCookie = null; }
    try { fromStore = parseVisitorRecord(env.storeGet(VID_NAME)); } catch (e2) { fromStore = null; }
    if (fromCookie) { src = "cookie"; rec = fromCookie; }
    else if (fromStore) { src = "storage"; rec = fromStore; }
    else { src = "new"; rec = parseVisitorRecord(mintVisitorRecord(env)); }
    try { env.cookieSet(VID_NAME, rec.record); } catch (e3) { /* never block on a cookie */ }
    try { env.storeSet(VID_NAME, rec.record); } catch (e4) { /* never block on storage */ }
    var age = Math.max(0, Math.floor((now / 1000 - rec.created) / 86400));
    this._identity = { visitor_id: rec.id, vid_source: src, vid_age_days: age };
    return this._identity;
  };

  // C5.2 — the telemetry beacon, through the consent gate: sent now when
  // consent allows it, HELD while consent is unknown (F-012), dropped when it
  // is denied. Anything held earlier goes out first, so order is kept.
  Client.prototype.beacon = function (event) {
    var st = this._settleConsent();
    if (st === "denied") { this.stats.beacons_suppressed++; return false; }
    if (st === "unknown") { this._hold({ type: "event", ev: event }); return false; }
    return this._send(event);
  };

  // The send itself — fire-and-forget. sendBeacon with a text/plain Blob keeps
  // it a CORS simple request (no preflight); fetch keepalive is the fallback.
  // NEVER throws.
  Client.prototype._send = function (event) {
    if (!this.host) { this.stats.beacon_failures++; return false; }
    var url = this.host + "/v1/events", body, self = this;
    try { body = JSON.stringify(event); } catch (e) { this.stats.beacon_failures++; return false; }
    try {
      if (this.env.sendBeacon && this.env.sendBeacon(url, body)) { this.stats.beacons_sent++; return true; }
    } catch (e1) { /* fall through to fetch */ }
    try {
      if (this.env.fetch) {
        var p = this.env.fetch(url, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" },
                                      body: body, keepalive: true, mode: "cors", credentials: "omit" });
        this.stats.beacons_sent++;
        if (p && typeof p.then === "function") {
          p.then(function (r) { if (r && r.status >= 400) self.stats.beacon_failures++; },
                 function () { self.stats.beacon_failures++; });
        }
        return true;
      }
    } catch (e2) { /* fire-and-forget */ }
    this.stats.beacon_failures++;
    return false;
  };

  // C5.4 — the cart ids, through the consent gate (held while unknown, F-012;
  // the emailed-link landing's write goes the same way).
  Client.prototype.writeCartAttributes = function (quizResponseId) {
    var self = this;
    if (!this.env.fetch) return Promise.resolve(false);
    var st = this._settleConsent();
    if (st === "denied") return Promise.resolve(false);
    if (st === "unknown") {
      return new Promise(function (resolve) { self._hold({ type: "cart", rid: quizResponseId, resolve: resolve }); });
    }
    return this._writeCart(quizResponseId);
  };

  // POST /cart/update.js with EXACTLY the two opaque ids. Shopify merges
  // attributes, so existing keys (bundle_id, igId, ...) are left untouched.
  Client.prototype._writeCart = function (quizResponseId) {
    var self = this;
    var id = this.identity();
    var body = cartAttributeBody(quizResponseId, id.visitor_id);
    try {
      return this.env.fetch("/cart/update.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body)
      }).then(function (r) {
        var ok = !!r && r.status === 200;
        if (ok) self.stats.cart_writes++; else self.stats.cart_failures++;
        return ok;
      }, function () { self.stats.cart_failures++; return false; });
    } catch (e) { this.stats.cart_failures++; return Promise.resolve(false); }
  };

  // The quiz's own add action (one card, or add-all). It is NOT a bundle
  // (Decision 22): each recommended single product goes in as its own line.
  Client.prototype.addToCart = function (items, quizResponseId) {
    var self = this;
    if (!this.env.fetch) return Promise.resolve({ ok: false });
    try {
      return this.env.fetch("/cart/add.js", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        var ok = !!r && r.status === 200;
        var ids = self.writeCartAttributes(quizResponseId);
        // While consent is unknown the id write is HELD and may wait forever:
        // the shopper's add must never hang on it (build 3 review).
        if (self.consentState() === "unknown") return { ok: ok };
        return ids.then(function () { return { ok: ok }; });
      }, function () { return { ok: false }; });
    } catch (e) { return Promise.resolve({ ok: false }); }
  };

  // C5.3 — the one completion write, through the consent gate. Resolves to
  // {status:'ready', url} or {status:'unavailable'}; never rejects. While
  // consent is unknown it resolves only once consent is known (the link reads
  // `pending` until then); if consent never arrives, nothing is ever sent.
  Client.prototype.complete = function (body) {
    var self = this;
    var unavailable = { status: "unavailable", url: null };
    if (!this.host || !this.env.fetch) return Promise.resolve(unavailable);
    var st = this._settleConsent();
    if (st === "denied") return Promise.resolve(unavailable);
    if (st === "unknown") {
      return new Promise(function (resolve) { self._hold({ type: "completion", body: body, resolve: resolve }); });
    }
    return this._sendCompletion(body);
  };

  // The completion POST. Idempotent on quiz_response_id; the run's completion
  // key is attached HERE, at the moment of sending, from the private map — so
  // it is never sitting in a held body, a run, or anything a page exposes.
  Client.prototype._sendCompletion = function (body) {
    var self = this;
    var unavailable = { status: "unavailable", url: null };
    var wire = {};
    for (var k in body) if (Object.prototype.hasOwnProperty.call(body, k)) wire[k] = body[k];
    if (!wire.visitor_id) wire.visitor_id = this.identity().visitor_id || null;   // held before the id could exist
    var key = RUN_KEYS[wire.quiz_response_id];
    if (key) wire.completion_key = key;
    var ctrl = this.env.abortController ? this.env.abortController() : null;
    var timer = null;
    return new Promise(function (resolve) {
      var settled = false;
      function done(v) { if (!settled) { settled = true; resolve(v); } }
      if (ctrl) timer = self.env.setTimeout(function () { try { ctrl.abort(); } catch (e) {} done(unavailable); },
                                            self.completionTimeoutMs);
      try {
        self.env.fetch(self.host + "/v1/responses", {
          method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: JSON.stringify(wire),
          keepalive: true, mode: "cors", credentials: "omit", signal: ctrl ? ctrl.signal : undefined
        }).then(function (r) {
          if (!r || r.status !== 200) { self.stats.completion_failures++; return done(unavailable); }
          return r.json().then(function (j) {
            if (j && typeof j.token === "string" && /^[A-Za-z0-9_-]{22}$/.test(j.token)) {
              done({ status: "ready", url: resultUrl(self.resultBase, j.token) });
            } else { self.stats.completion_failures++; done(unavailable); }
          }, function () { self.stats.completion_failures++; done(unavailable); });
        }, function () { self.stats.completion_failures++; done(unavailable); });
      } catch (e) { self.stats.completion_failures++; done(unavailable); }
    });
  };

  // C5.5 — the ONE synchronous host call, and only on the emailed-link path
  // (the brief names the link as an acceptable loss). Resolves to the stored
  // result's IDS (which products, reasons and advice), {expired: true} when
  // the host answers 410 (the link is older than 90 days), or null. The host never
  // returns the shopper's answers or readback to a token holder (F-002), and a
  // reply in any other shape is treated as no reply at all.
  Client.prototype.fetchReturn = function (token) {
    if (!/^[A-Za-z0-9_-]{22}$/.test(String(token || "")) || !this.host || !this.env.fetch) return Promise.resolve(null);
    try {
      return this.env.fetch(this.host + "/v1/r/" + token, { method: "GET", mode: "cors", credentials: "omit" })
        .then(function (r) {
          if (r && r.status === 200) return r.json();
          // 410 = the link is past its 90 days (2026-09-24): say so, so the page
          // can offer a retake rather than a generic "not found".
          if (r && r.status === 410) {
            return r.json().then(function (j) { return (j && j.retake) ? { expired: true } : null; },
                                 function () { return null; });
          }
          return null;
        }, function () { return null; })
        .then(function (j) {
          if (j && j.expired === true) return j;
          return (j && j.schema === RETURN_SCHEMA && j.result) ? j : null;
        }, function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  };

  // ===========================================================================
  // A run: one engine session + its telemetry.
  // ===========================================================================
  function Run(client, o) {
    this.client = client;
    this.engine = o.engine;
    this.responseId = o.responseId || mintResponseId(client.env);
    // The run's completion key (F-013): minted once per response id for the
    // life of the page, stored ONLY in the file-private map (never on `this`).
    if (!RUN_KEYS[this.responseId]) RUN_KEYS[this.responseId] = randomId(client.env);
    this.entryPoint = o.entryPoint || "direct";
    this.session = this.engine.create({ content: o.content || null, entryPoint: this.entryPoint,
                                        responseId: this.responseId });
    this.contentVersion = o.content ? o.content.version : null;
    this.seq = 0;
    this.startedAt = null;
    this.lastStepAt = null;
    this.finished = false;
    this.link = { status: "pending", url: null };
    this.onLink = o.onLink || null;
    this.completion = null;
  }

  Run.prototype._emit = function (name, fields) {
    var c = this.client, id = c.identity();
    this.seq += 1;
    var ev = envelope({ eventId: uuid4(c.env), responseId: this.responseId, visitorId: id.visitor_id,
                        vidSource: id.vid_source, vidAgeDays: id.vid_age_days, now: c.env.now(), seq: this.seq,
                        contentVersion: this.contentVersion, engineVersion: this.engine.VERSION.engine,
                        synthetic: c.synthetic }, name, fields);
    c.beacon(ev);
    return ev;
  };

  Object.defineProperty(Run.prototype, "state", { get: function () { return this.session.state; } });
  Object.defineProperty(Run.prototype, "result", {
    get: function () {
      var m = this.session.result;
      if (m) m.link = { status: this.link.status, url: this.link.url };
      return m;
    }
  });

  Run.prototype.start = function () {
    var now = this.client.env.now();
    this.startedAt = now; this.lastStepAt = now;
    if (this.session.state.phase === "unavailable") return this.session.state;
    this._emit("quiz_started", { entry_point: this.entryPoint, ua_family: uaFamily(this.client.env.userAgent) });
    return this.session.state;
  };

  Run.prototype.answer = function (questionId, optionIds) {
    if (this.startedAt === null) this.start();
    var before = this.session.state;
    var st = this.session.answer(questionId, optionIds);
    if (st.error) return st;
    var now = this.client.env.now();
    var ans = this.session.answers[this.session.answers.length - 1];
    var fields = { question_id: ans.question_id, stage: ans.stage, option_ids: ans.option_ids,
                   elapsed_ms: Math.max(0, now - this.lastStepAt), revision: ans.revision };
    if (before.question && before.question.kind === "top_pick") fields.top_pick = this.session.topNeed;
    this.lastStepAt = now;
    this._emit("question_answered", fields);
    if (st.phase !== "interview" && !this.finished) {
      this._emit("quiz_completed", { answer_count: this.session.answers.length,
                                     path_length: this.session.answers.length,
                                     elapsed_ms: Math.max(0, now - this.startedAt) });
      if (st.phase === "result") this._finish({});
    }
    return st;
  };

  Run.prototype.back = function () { return this.session.back(); };

  // Decision 16: skippable, after the questions, before the reveal. The email
  // goes ONLY to the completion write (never into an event, never onto the cart).
  // An address the host would refuse counts as no address (F-006): the page
  // should check it first with OmQuizClient.validEmail and ask again.
  Run.prototype.completeGate = function (o) {
    o = o || {};
    var email = validEmail(o.email);
    var st = this.session.completeGate({ given: !!email });
    if (st.phase === "result" && !this.finished) this._finish({ email: email, consent: !!o.consent });
    return st;
  };

  Run.prototype._finish = function (o) {
    this.finished = true;
    var model = this.session.result, self = this;
    this._emit("result_shown", resultShownFields(model));
    var body = {
      quiz_response_id: this.responseId, visitor_id: this.client.identity().visitor_id,
      content_version: this.contentVersion, engine_version: this.engine.VERSION.engine,
      entry_point: this.entryPoint, answers: this.session.answers, result_snapshot: model,
      synthetic: this.client.synthetic
    };
    if (o.email) { body.email = o.email; body.email_consent = !!o.consent; }
    this.completion = this.client.complete(body).then(function (link) {
      self.link = link;
      if (self.onLink) { try { self.onLink(link); } catch (e) { /* page callback must not break us */ } }
      return link;
    });
    // The ids reach the cart only AFTER the genuine completion is on its way:
    // every storefront script can read the cart, and the first completion for
    // an id wins (build 3 review, F-013). Still before any add, so a later add
    // from a PDP carries them.
    this.client.writeCartAttributes(this.responseId);
    return this.completion;
  };

  // The card CTAs. Each emits recommendation_clicked (the rank picked is logged,
  // never proof of ranking quality) and writes the cart ids again. start_broad
  // works too (no rank: logs null). No add-all since 2026-09-24.
  Run.prototype.add = function (card) {
    this._emit("recommendation_clicked", { product_id: card.product.id, rank: card.rank || null, action: "add" });
    return this.client.addToCart([{ id: parseInt(card.add.variant_id, 10), quantity: card.add.quantity || 1 }],
                                 this.responseId);
  };

  Run.prototype.view = function (card) {
    this._emit("recommendation_clicked", { product_id: card.product.id, rank: card.rank || null, action: "view" });
  };

  Client.prototype.startRun = function (o) { return new Run(this, o || {}); };

  // The emailed-link landing: fetch the stored result's ids and rebuild the
  // result on CURRENT content (ADR-16 as amended by F-002: no answers come back,
  // so nothing is re-ranked; what is no longer eligible is dropped and COUNTED
  // in model.dropped). Resolves to a result model (model.retake true = invite a
  // retake; model.expired true = the link is past its 90 days), or null.
  Client.prototype.resolveReturn = function (o) {
    var self = this;
    var token = o.token || parseResultToken(o.hash, o.search);
    if (!token) return Promise.resolve(null);
    return this.fetchReturn(token).then(function (view) {
      if (!view) return null;
      // An expired link still gets a model (retake + expired), rebuilt on the
      // current content so the caution line and start_broad ride it too.
      var model = o.engine.resolveReturn(view, o.content);
      if (model && view.quiz_response_id) {
        // A purchase after the return visit still joins to the original run.
        // (The id is a join key that rides the order anyway, never a credential.)
        self.writeCartAttributes(view.quiz_response_id);
      }
      return model;
    }, function () { return null; });
  };

  // Read the JSON the Liquid snippet rendered. Never throws.
  function readPageContent(elementId) {
    // consent_mode starts GATED: a page whose content cannot be read must never
    // fall back to capturing without consent (Decision 27).
    var out = { content: null, content_prev: null, pointer: null, quiz_live: null, host: null,
                result_path: null, consent_mode: DEFAULT_CONSENT_MODE, staging: false };
    try {
      if (typeof document === "undefined") return out;
      var el = document.getElementById(elementId || "om-quiz-content");
      if (!el) return out;
      var raw = JSON.parse(el.textContent || "{}");
      for (var k in raw) if (Object.prototype.hasOwnProperty.call(raw, k)) out[k] = raw[k];
      var c = raw.content || raw.content_prev;
      if (c && c.config) {
        out.host = out.host || (c.config.endpoints && c.config.endpoints.host) || null;
        out.result_path = out.result_path || (c.config.endpoints && c.config.endpoints.result_path) || null;
        out.consent_mode = c.config.capture_consent_mode || out.consent_mode;
      }
    } catch (e) { /* fail open: an unreadable tag means 'unavailable', never a crash */ }
    return out;
  }

  var OmQuizClient = {
    VERSION: CLIENT_VERSION,
    EVENT_SCHEMA: EVENT_SCHEMA,
    RETURN_SCHEMA: RETURN_SCHEMA,
    DEFAULT_CONSENT_MODE: DEFAULT_CONSENT_MODE,
    EVENT_NAMES: EVENT_NAMES,
    create: function (o) { return new Client(o || {}); },
    readPageContent: readPageContent,
    // The page's email check: the host's own rule (F-006). Returns the trimmed
    // address, or null when the host would refuse it.
    validEmail: validEmail,
    // Pure helpers, exported for the Node tests.
    _internal: { b64url: b64url, uuid4: uuid4, mintResponseId: mintResponseId, mintVisitorRecord: mintVisitorRecord,
                 parseVisitorRecord: parseVisitorRecord, uaFamily: uaFamily, cartAttributeBody: cartAttributeBody,
                 resultUrl: resultUrl, parseResultToken: parseResultToken, envelope: envelope,
                 resultShownFields: resultShownFields }
  };

  if (typeof module !== "undefined" && module.exports) {
    module.exports = OmQuizClient;
  } else {
    root.OmQuizClient = OmQuizClient;
  }
})(this);
